// Frame bounds are in points; template width/height are in the document's ruler unit
const POINTS_PER_UNIT: Record<string, number> = {
    points: 1,
    picas: 12,
    inches: 72,
    inches_decimal: 72,
    millimeters: 72 / 25.4,
    centimeters: 720 / 25.4,
    ciceros: 12.7892,
    agates: 72 / 14,
    pixels: 1,
    mils: 0.072,
};

/** Unknown units are treated as points. */
export function toPoints(value: number, measurementUnit?: string): number {
    if (!Number.isFinite(value)) {
        return 0;
    }

    return value * (POINTS_PER_UNIT[String(measurementUnit ?? "").toLowerCase()] ?? 1);
}
